import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {catchError, tap} from 'rxjs/operators';
import {HandleErrorService} from './handle-error.service';
import Swal from 'sweetalert2';
import {ApiService} from '../core/services/api.service';

@Injectable({
  providedIn: 'root'
})
export class FooterService {

  constructor(private serviceApi: ApiService, private handleError: HandleErrorService) {
  }

  getFooterData(): Observable<any> {
    return this.serviceApi.get(`Configuration/ConfigurationFooter`)
      .pipe(
        catchError(this.handleError.catchHttpError)
      );
  }

  editFooterLogo(body): Observable<any> {
    return this.serviceApi.put(`Footer/ULogo`, body)
      .pipe(
        catchError(this.handleError.catchHttpError),
        tap((data: { valid: boolean, message: string }) => {
          if (data.valid) {
            Swal.fire({
              icon: 'success',
              confirmButtonText: 'Aceptar',
              text: data.message
            });
          }
        })
      );
  }

  editContactInformation(body): Observable<any> {
    return this.serviceApi.put(`Footer/UContact`, body)
      .pipe(
        catchError(this.handleError.catchHttpError),
        tap((data: { valid: boolean, message: string }) => {
          if (data.valid) {
            Swal.fire({
              icon: 'success',
              confirmButtonText: 'Aceptar',
              text: data.message
            });
          }
        })
      );
  }

  editInformation(body): Observable<any> {
    return this.serviceApi.put(`Footer/UInformation`, body)
      .pipe(
        catchError(this.handleError.catchHttpError),
        tap((data: { valid: boolean, message: string }) => {
          if (data.valid) {
            Swal.fire({
              icon: 'success',
              confirmButtonText: 'Aceptar',
              text: data.message
            });
          }
        })
      );
  }

  editSectionOne(body): Observable<any> {
    return this.serviceApi.put(`Footer/UUrl1`, body)
      .pipe(
        catchError(this.handleError.catchHttpError),
        tap((data: { valid: boolean, message: string }) => {
          if (data.valid) {
            Swal.fire({
              icon: 'success',
              confirmButtonText: 'Aceptar',
              text: data.message
            });
          }
        })
      );
  }

  editSectionTwo(body): Observable<any> {
    return this.serviceApi.put(`Footer/UUrl2`, body)
      .pipe(
        catchError(this.handleError.catchHttpError),
        tap((data: { valid: boolean, message: string }) => {
          if (data.valid) {
            Swal.fire({
              icon: 'success',
              confirmButtonText: 'Aceptar',
              text: data.message
            });
          }
        })
      );
  }

  changeStatusSectionOne(body): Observable<any> {
    return this.serviceApi.patch(`Footer/StatusSection1`, body)
      .pipe(
        catchError(this.handleError.catchHttpError),
        tap((data: { valid: boolean, message: string }) => {
          if (data.valid) {
            Swal.fire({
              icon: 'success',
              confirmButtonText: 'Aceptar',
              text: data.message
            });
          }
        })
      );
  }

  changeStatusSectionTwo(body): Observable<any> {
    return this.serviceApi.patch(`Footer/StatusSection2`, body)
      .pipe(
        catchError(this.handleError.catchHttpError),
        tap((data: { valid: boolean, message: string }) => {
          if (data.valid) {
            Swal.fire({
              icon: 'success',
              confirmButtonText: 'Aceptar',
              text: data.message
            });
          }
        })
      );
  }

}
